import React from 'react';
import { Card, Row, Col, Space } from 'antd';
import { findIntersectingPositions } from "../utils";

const PositionCard = ({ title, items, highlight }) => {
  const gradient = highlight ? 'linear-gradient(to bottom right, #a1ffce, #88d3ce)' : 'linear-gradient(to bottom right, #dfe9f3, #ffffff)';

  return (
    <Card
        title={title}
        extra={
        <Space>
            {items.length}
        </Space>}
        style={{ margin: '10px', background: gradient }}
    >
      <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }}>
          {items.map((item, index) => (
            <div key={index} style={{ width: '50%', padding: '2px 5px' }}>
              {index + 1}. {item}
            </div>
          ))}
        </div>
      </div>
    </Card>
  );
};


const IntersectingPositions = ({ positions }) => {
    console.log('positions', positions)
    const intersectingPositions = findIntersectingPositions(positions);
  return (
    <Row gutter={16} style={{ padding: '20px' }}>
      {Object.keys(intersectingPositions).map((key) => (
        <Col span={8} key={key}>
          <PositionCard
            title={`Owned by ${key}`}
            items={intersectingPositions[key]}
            highlight={key === 'all'}
          />
        </Col>
      ))}
    </Row>
  );
};

export default IntersectingPositions